import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { Button, ButtonVariantOption, SubmitButton } from "../Button";
import { useIsMobile } from "@/hooks/useIsMobile";

interface Props {
  dialogContentText: string;
  handleClickSubmitAddRowsButton: (cancelLoading: () => void) => void;
  openAddRowsModalFlag: boolean;
  setOpenAddRowsModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * 家屋番号領域のボタン押下時に表示されるダイアログ
 * @param {Props} props
 * @returns {React.FC<Props>}
 */
export const ConfirmDialogKaokuNumber: React.FC<Props> = (props) => {
  const {
    dialogContentText,
    handleClickSubmitAddRowsButton,
    openAddRowsModalFlag,
    setOpenAddRowsModalFlag,
  } = props;
  const isMobile = useIsMobile();

  return (
    <Dialog
      open={openAddRowsModalFlag}
      fullScreen={isMobile}
      onClose={(_, reason) => {
        // 誤タップで閉じないよう、背景タップ・Esc では閉じない
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        setOpenAddRowsModalFlag(false);
      }}
    >
      <DialogTitle>{"確認画面"}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogContentText}</DialogContentText>
        <DialogContentText>よろしいですか？</DialogContentText>
      </DialogContent>
      {/* 共通 Button は SP で幅100%になるため、内容幅で包む */}
      <DialogActions>
        <Box sx={{ width: "fit-content" }}>
          <Button
            variant={ButtonVariantOption.Outlined}
            onClick={() => {
              setOpenAddRowsModalFlag(false);
            }}
            label={"キャンセル"}
          />
        </Box>
        <Box sx={{ width: "fit-content" }}>
          <SubmitButton
            variant={ButtonVariantOption.Contained}
            onClick={(_event, cancelLoading) => {
              handleClickSubmitAddRowsButton(cancelLoading);
            }}
            label={"はい"}
            timeout={3000}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};
